import React from 'react';
import styled from 'styled-components';

import { ButtonProps } from '@make-software/cspr-design';
import { Button } from '@block-explorer/ui';

import { useCustomHistory } from '../../router/navigation';
import { DELEGATE_STAKE_PATH } from '../../router/paths';
import { buildRouterPath } from '../../router/utils';
import { Validator } from '@block-explorer/entities';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DelegateButtonProps extends ButtonProps {
  validatorInfo: Validator | null;
  showShortLabel?: boolean;
}

export function DelegateButton({
  validatorInfo: validator,
  showShortLabel,
  width,
  ...props
}: DelegateButtonProps) {
  const { t } = useTranslation();
  const history = useCustomHistory();
  const validatorPublicKey = validator?.key;

  if (validator == null || !validatorPublicKey) {
    return null;
  }

  if (!validator.active) {
    return null;
  }

  const label =
    showShortLabel || width === '100' ? t('Delegate') : t('Delegate Stake');

  return (
    <Button
      color="primaryRed"
      width={width}
      onClick={(ev) => {
        ev.stopPropagation();
        history.push(
          buildRouterPath(DELEGATE_STAKE_PATH, undefined, {
            validatorPublicKey: validatorPublicKey,
          }),
          { allowedGoBack: true }
        );
      }}
      {...props}
    >
      {label}
    </Button>
  );
}

export default DelegateButton;
